import moment from "moment";

/**
 * Collect YYYY-MM-DD keys for days covered by events (DateStart..DateEnd),
 * optionally filtered by event type ids and month (YYYY-MM).
 */
export function collectEventDateKeys(events, { types = null, month = null } = {}) {
  const keys = new Set();

  (events || []).forEach((event) => {
    const idType = event.IdType ?? event.idType;
    if (types && types.length && !types.includes(idType)) {
      return;
    }

    const start = moment(event.DateStart || event.dateStart);
    const end = moment(event.DateEnd || event.dateEnd || event.DateStart);
    if (!start.isValid()) {
      return;
    }

    const rangeEnd =
      end.isValid() && (end.isAfter(start, "day") || end.isSame(start, "day"))
        ? end
        : start;
    const cursor = start.clone().startOf("day");
    const last = rangeEnd.clone().startOf("day");

    while (cursor.isBefore(last, "day") || cursor.isSame(last, "day")) {
      const key = cursor.format("YYYY-MM-DD");
      if (!month || key.startsWith(month)) {
        keys.add(key);
      }
      cursor.add(1, "day");
    }
  });

  return Array.from(keys);
}

export function filterEventsByTypes(events, types) {
  if (!types || !types.length) {
    return events || [];
  }
  return (events || []).filter((event) =>
    types.includes(event.IdType ?? event.idType)
  );
}
